import { PRODUCT_TYPE } from '~/constants/ProductType';


export default function useProductType () {
  const isSubscription = (productTypeKey) => {
    return productTypeKey === PRODUCT_TYPE.MOBILE_SUBSCRIPTION || productTypeKey === PRODUCT_TYPE.MOBILE_BROADBAND_SUBSCRIPTION
  }
  const isMobileVoiceSubscription = (productTypeKey) => {
    return productTypeKey === PRODUCT_TYPE.MOBILE_SUBSCRIPTION
  }
  const isMobileBroadBandSubscription = (productTypeKey) => {
    return productTypeKey === PRODUCT_TYPE.MOBILE_BROADBAND_SUBSCRIPTION
  }
  // MIO-29627: mirrors backend ProductType.isProductTypeKeyHardware
  const isHardware = (productTypeKey) => {
    return productTypeKey === PRODUCT_TYPE.DEVICE ||
      productTypeKey === PRODUCT_TYPE.ACCESSORY ||
      productTypeKey === PRODUCT_TYPE.MOBILE_BROADBAND_HARDWARE
  }
  return {
    isMobileBroadBandSubscription,
    isSubscription,
    isMobileVoiceSubscription,
    isHardware
  }
}
